export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de-at',
  fallbackLocale: 'de-at',
}))
